export default (arg: any): arg is string => typeof arg === "string"
